import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { Request } from '../../../api';
import { Asset, AttributeValue, Individual, ResponseWithPagination } from '../../../utils';
import { ExternalId } from '../community.types';

export function updateIndividual(
    individualId: string,
    payload: {
        name: string;
        attributes: Array<Pick<AttributeValue, 'name' | 'value' | 'type'>>;
        profile_photo?: string;
        athletic_net_profile_url?: string | null;
    },
): Promise<AxiosResponse<Individual>> {
    return Request.put(`/individuals/${individualId}`, payload);
}

export function deleteIndividual(individualId: string): Promise<AxiosResponse<void>> {
    return Request.delete(`/individuals/${individualId}`);
}

export function getVideos(
    individualId: string,
    page: number,
): Promise<AxiosResponse<ResponseWithPagination<Asset>>> {
    return Request.get(`/individuals/${individualId}/videos`, { params: { page } });
}

export function createVideo(
    individualId: string,
    path: string,
    date?: DateTime | undefined,
): Promise<AxiosResponse<Asset>> {
    return Request.post(`/individuals/${individualId}/videos`, {
        path,
        datetime: date?.toFormat('yyyy-MM-dd HH:mm:ss'),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
}

export function deleteVideo(id: string, individualId: string): Promise<AxiosResponse<Asset>> {
    return Request.delete(`/individuals/${individualId}/videos/${id}`);
}

export function getExternalIds(individualId: string): Promise<AxiosResponse<Array<ExternalId>>> {
    return Request.get(`/individuals/${individualId}/external-ids`);
}

export function importTemData(individualId: string, params = {}): Promise<AxiosResponse<void>> {
    return Request.post(`/individuals/${individualId}/import-tem-data`, params);
}

export interface ManagingUserOption {
    uuid: string;
    first_name: string;
    last_name: string;
    user_name: string;
    email: string;
}

export interface AssignManagingUserNewUserPayload {
    first_name: string;
    last_name: string;
    user_name: string;
    password: string;
    email?: string;
    phone?: string;
    primary_sport?: string;
}

export interface AssignManagingUserExistingPayload {
    user_uuid: string;
}

export type AssignManagingUserPayload =
    | AssignManagingUserNewUserPayload
    | AssignManagingUserExistingPayload;

export function getOrganizationManagingUsers(
    organizationUuid: string,
): Promise<AxiosResponse<{ data: ManagingUserOption[] }>> {
    return Request.get(`/organizations/${organizationUuid}/managing-users`);
}

export function assignManagingUserToIndividual(
    individualUuid: string,
    payload: AssignManagingUserPayload,
): Promise<AxiosResponse<{ individual: Individual; message: string }>> {
    return Request.post(`/individuals/${individualUuid}/assign-managing-user`, payload);
}
